import { useState } from 'react'
import Date from '../../../../Core/Fields/Floating/Date';
import Input from '../../../../Core/Fields/Floating/Input';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

const Tab1 = ({ ItemGroupName,ParentItemGroup,UnicommerceProductCategoryCode,IsGroup}) => {

  return (
   <div
      className="row mb-3"
      style={{ border: "1px solid #00000059", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">Details</p>
      </div>
      <div className="col-4 ">
        <div className="mb-3">
          <Input
            id="ItemGroupName"
            label="Item Group Name"
            style={{ height: "30px",border: ItemGroupName.Error ? "1px solid red" : "", }}
            value={ItemGroupName.ItemGroupName}
            onChange={(e) => ItemGroupName.setItemGroupName(e.target.value)}
          />
        </div>
      </div>
      
      <div className="col-4 ">
        <div className="mb-3">
          <SelectSearch
              list={ParentItemGroup.ParentItemGroup_list}
              style={{
                height: "30px",
                border: ParentItemGroup.Error ? "1px solid red" : "",
              }}
              label="Parent Item Group"
              getOptionLabel={(item) => item.isNew ? "+ Create New Item Group":item.name} // 👈 Required
              getOptionValue={(item) => item.name} // 👈 Required
              value={ParentItemGroup.select_ParentItemGroup}
              createNewLabel='Create New Item Group'
              createNewUrl='/master/itemgroup/create-item-group'
              onChange={(val) => ParentItemGroup.setselect_ParentItemGroup(val)}
            />
            
        </div>
      </div>
     
      <div className="col-4 ">
        <div className="mb-3">
          <Input
            id="UnicommerceProductCategoryCode"
            style={{
              height: "30px",
              border: UnicommerceProductCategoryCode.Error ? "1px solid red" : "",
            }}
            label="Unicommerce Product Category Code"
            value={UnicommerceProductCategoryCode.UnicommerceProductCategoryCode}
            onChange={(e) => UnicommerceProductCategoryCode.setUnicommerceProductCategoryCode(e.target.value)}
          />
        </div>
      </div>

      <div className="col-4 ">
        <div className="mb-3">
        
 <Checkbox
            id="IsGroup"
            label="Is Group"
            value={IsGroup?.IsGroup || false}
            onChange={(val) => IsGroup?.setIsGroup?.(val)}
          />
<div style={{ fontSize: "9px", color: "#00000099", marginLeft:'23px' }}>
    Only leaf nodes are allowed in transaction
  </div>
        </div>
      </div>


    </div>
  )
}

export default Tab1